export const invoiceConstants = {
  SAVE_INVOICES_LIST_URL: 'SAVE_INVOICES_LIST_URL',
};
